global.EUCUtils = (function () {

  function replaceUrlParam(url, paramName, paramValue) {
    if (paramValue == null) {
      paramValue = '';
    }
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (url.search(pattern) >= 0) {
      return url.replace(pattern, '$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/, '');
    return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
  }

  function processResponse(ajaxHref, target, data, status, xhr, dataType, historyHref) {
    if (typeof (data) == "object") {
      if (data.hasOwnProperty("redirectUrl")) {
        var url = data.redirectUrl;
        location.href = url;
      } else {
        console.warn("Unknow response: ");
        console.warn(data);
      }
    } else {
      var $observeInput = $('.jsObserveInput');
      target.replaceWith(data);
      var $alert = $('.jsReloadAlert');
      if ($alert.length > 0) {
        $('html, body').animate({
          scrollTop: ($alert.first().offset().top)
        }, 500);
      } else {
        var $anchor = $('.jsReloadAnchor');
        if ($anchor.length > 0) {
          $('html, body').animate({
            scrollTop: ($anchor.first().offset().top)
          }, 500);
        }
      }

      if (typeof historyHref !== "undefined") {
        history.pushState(null, null, historyHref);
        $(document).trigger("reload:pushstate", {ajaxHref: ajaxHref, xhr: xhr});
      }
      if ($observeInput.length > 0) {
        $('.jsObserveInput').val($observeInput.val());
      }
      $(document).trigger("reload:completed", {ajaxHref: ajaxHref, xhr: xhr});
    }
  }

  function reload(ajaxHref, target, historyHref, callback) {
    $('.Loader').addClass("isActive");
    $.get(ajaxHref, function (data, status, xhr, dataType) {
      processResponse(ajaxHref, target, data, status, xhr, dataType, historyHref);
      if (callback !== undefined) {
        callback();
      }
      $('.Loader').removeClass("isActive");
    });
  }

  function reloadPost(ajaxHref, target, data, callback) {
    $('.Loader').addClass("isActive");
    $.post(ajaxHref, data, function (data, status, xhr, dataType) {
      processResponse(ajaxHref, target, data, status, xhr, dataType);
      if (callback !== undefined) {
        callback();
      }
      $('.Loader').removeClass("isActive");
    });
  }

  function createCookie(name, value, days) {
    var expires;

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
  }

  function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  }

  return {
    reload: reload,
    reloadPost: reloadPost,
    replaceUrlParam: replaceUrlParam,
    createCookie: createCookie,
    readCookie: readCookie
  }
})();
